import React, { useEffect, useState } from "react";
import {
  fetchUtilizadores, updateUtilizador,
  fetchConvites, createConvite, deleteConvite,
  fetchProjectManagers,
  fetchLinksAcesso, createLinkAcesso, revogarLinkAcesso,
} from "../../services/api";

const ROLES = ["admin", "head", "pm", "viewer"];
const AREAS = ["", "Media & PR", "Influence & Digital", "Events", "Transversal"];

export default function UserSettings() {
  const [utilizadores, setUtilizadores] = useState([]);
  const [loading, setLoading]           = useState(true);
  const [salvando, setSalvando]         = useState({});
  const [feedback, setFeedback]         = useState({});
  const [editando, setEditando]         = useState({});
  const [pms, setPms]                   = useState([]);

  const [convites, setConvites]               = useState([]);
  const [novoEmail, setNovoEmail]             = useState("");
  const [novoRole, setNovoRole]               = useState("head");
  const [conviteFeedback, setConviteFeedback] = useState(null);
  const [enviando, setEnviando]               = useState(false);

  const [links, setLinks]                     = useState([]);
  const [novoLinkNome, setNovoLinkNome]       = useState("");
  const [novoLinkDias, setNovoLinkDias]       = useState(30);
  const [linkGerado, setLinkGerado]           = useState(null);
  const [linkFeedback, setLinkFeedback]       = useState(null);
  const [gerandoLink, setGerandoLink]         = useState(false);

  useEffect(() => {
    fetchUtilizadores()
      .then(setUtilizadores)
      .catch(console.error)
      .finally(() => setLoading(false));
    fetchConvites().then(setConvites).catch(() => {});
    fetchProjectManagers().then(setPms).catch(() => {});
    fetchLinksAcesso().then(setLinks).catch(() => {});
  }, []);

  const convidar = async () => {
    if (!novoEmail.trim()) return;
    setEnviando(true);
    setConviteFeedback(null);
    try {
      const c = await createConvite(novoEmail.trim(), novoRole);
      setConvites((prev) => [c, ...prev]);
      setNovoEmail("");
      setConviteFeedback({ tipo: "ok", msg: "Convite criado." });
    } catch (e) {
      setConviteFeedback({ tipo: "erro", msg: e.message });
    } finally {
      setEnviando(false);
    }
  };

  const removerConvite = async (email) => {
    try {
      await deleteConvite(email);
      setConvites((prev) => prev.filter((c) => c.email !== email));
    } catch (e) {
      console.error(e);
    }
  };

  const gerarLink = async () => {
    if (!novoLinkNome.trim()) return;
    setGerandoLink(true);
    setLinkFeedback(null);
    setLinkGerado(null);
    try {
      const l = await createLinkAcesso(novoLinkNome.trim(), novoLinkDias ? Number(novoLinkDias) : null);
      setLinks((prev) => [
        { id: l.id, nome: l.nome, criado_por: null, criado_em: new Date().toISOString(), expira_em: l.expira_em, revogado: 0, ultimo_acesso: null },
        ...prev,
      ]);
      setLinkGerado(l.url);
      setNovoLinkNome("");
    } catch (e) {
      setLinkFeedback({ tipo: "erro", msg: e.message });
    } finally {
      setGerandoLink(false);
    }
  };

  const revogarLink = async (id) => {
    try {
      await revogarLinkAcesso(id);
      setLinks((prev) => prev.map((l) => (l.id === id ? { ...l, revogado: 1 } : l)));
    } catch (e) {
      console.error(e);
    }
  };

  const guardar = async (userId) => {
    setSalvando((prev) => ({ ...prev, [userId]: true }));
    setFeedback((prev) => ({ ...prev, [userId]: null }));
    try {
      await updateUtilizador(userId, editando[userId]);
      setUtilizadores((prev) =>
        prev.map((u) => (u.user_id === userId ? { ...u, ...editando[userId] } : u))
      );
      setFeedback((prev) => ({ ...prev, [userId]: { tipo: "ok", msg: "Guardado." } }));
    } catch (e) {
      setFeedback((prev) => ({ ...prev, [userId]: { tipo: "erro", msg: e.message } }));
    } finally {
      setSalvando((prev) => ({ ...prev, [userId]: false }));
    }
  };

  const handleChange = (userId, campo, valor) => {
    setEditando((prev) => ({
      ...prev,
      [userId]: { ...(prev[userId] || {}), [campo]: valor },
    }));
  };

  const getValor = (user, campo) =>
    editando[user.user_id]?.[campo] !== undefined
      ? editando[user.user_id][campo]
      : user[campo];

  if (loading) return <p style={s.loading}>A carregar utilizadores…</p>;

  return (
    <div style={s.wrapper}>

      <div style={s.section}>
        <h3 style={s.titulo}>Acesso por Convite</h3>
        <p style={s.descricao}>Adiciona o email de quem queres convidar. Só essas pessoas conseguem entrar.</p>

        <div style={s.formRow}>
          <input
            style={s.input}
            type="email"
            placeholder="email@companhiasolucoes.com"
            value={novoEmail}
            onChange={(e) => setNovoEmail(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && convidar()}
          />
          <select style={s.select} value={novoRole} onChange={(e) => setNovoRole(e.target.value)}>
            <option value="head">head</option>
            <option value="admin">admin</option>
            <option value="pm">pm</option>
            <option value="viewer">viewer</option>
          </select>
          <button style={s.btn} onClick={convidar} disabled={enviando || !novoEmail.trim()}>
            {enviando ? "…" : "Convidar"}
          </button>
          {conviteFeedback && (
            <span style={conviteFeedback.tipo === "ok" ? s.ok : s.erro}>
              {conviteFeedback.msg}
            </span>
          )}
        </div>

        {convites.length > 0 && (
          <div className="table-scroll">
          <table style={{ ...s.tabela, marginTop: 16 }}>
            <thead>
              <tr>
                <th style={s.th}>Email</th>
                <th style={s.th}>Role</th>
                <th style={s.th}>Convidado em</th>
                <th style={s.th}></th>
              </tr>
            </thead>
            <tbody>
              {convites.map((c) => (
                <tr key={c.email}>
                  <td style={s.td}>{c.email}</td>
                  <td style={s.td}>{c.role}</td>
                  <td style={s.td}>{c.criado_em?.slice(0, 16).replace("T", " ")}</td>
                  <td style={s.td}>
                    <button style={s.btnRemover} onClick={() => removerConvite(c.email)}>
                      Remover
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>

      <div style={s.section}>
        <h3 style={s.titulo}>Acessos Externos</h3>
        <p style={s.descricao}>
          Gera um link de visualização para alguém sem email da Companhia (ex. um consultor).
          Quem abrir o link entra diretamente com acesso de visualização (role "viewer"), sem precisar de conta Microsoft.
        </p>

        <div style={s.formRow}>
          <input
            style={s.input}
            type="text"
            placeholder="Nome / identificação (ex. Consultor XPTO)"
            value={novoLinkNome}
            onChange={(e) => setNovoLinkNome(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && gerarLink()}
          />
          <input
            style={{ ...s.input, minWidth: 100 }}
            type="number"
            min="1"
            placeholder="Dias"
            value={novoLinkDias}
            onChange={(e) => setNovoLinkDias(e.target.value)}
            title="Validade em dias (vazio = sem expiração)"
          />
          <button style={s.btn} onClick={gerarLink} disabled={gerandoLink || !novoLinkNome.trim()}>
            {gerandoLink ? "…" : "Gerar link"}
          </button>
          {linkFeedback && <span style={s.erro}>{linkFeedback.msg}</span>}
        </div>

        {linkGerado && (
          <div style={s.linkGerado}>
            <strong>Guarda este link agora — não voltará a ser mostrado:</strong>
            <div style={s.linkGeradoUrl}>{linkGerado}</div>
          </div>
        )}

        {links.length > 0 && (
          <div className="table-scroll">
          <table style={{ ...s.tabela, marginTop: 16 }}>
            <thead>
              <tr>
                <th style={s.th}>Nome</th>
                <th style={s.th}>Criado em</th>
                <th style={s.th}>Expira em</th>
                <th style={s.th}>Último acesso</th>
                <th style={s.th}>Estado</th>
                <th style={s.th}></th>
              </tr>
            </thead>
            <tbody>
              {links.map((l) => (
                <tr key={l.id}>
                  <td style={s.td}>{l.nome}</td>
                  <td style={s.td}>{l.criado_em?.slice(0, 16).replace("T", " ")}</td>
                  <td style={s.td}>{l.expira_em ? l.expira_em.slice(0, 16).replace("T", " ") : "— sem expiração —"}</td>
                  <td style={s.td}>{l.ultimo_acesso ? l.ultimo_acesso.slice(0, 16).replace("T", " ") : "—"}</td>
                  <td style={s.td}>{l.revogado ? <span style={s.erro}>Revogado</span> : <span style={s.ok}>Ativo</span>}</td>
                  <td style={s.td}>
                    {!l.revogado && (
                      <button style={s.btnRemover} onClick={() => revogarLink(l.id)}>
                        Revogar
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>

      <div style={s.section}>
        <h3 style={s.titulo}>Utilizadores Registados ({utilizadores.length})</h3>

        {utilizadores.length === 0 ? (
          <p style={s.semDados}>
            Nenhum utilizador registado. Os utilizadores são criados automaticamente no primeiro login.
          </p>
        ) : (
          <div className="table-scroll">
          <table style={s.tabela}>
            <thead>
              <tr>
                <th style={s.th}>Nome</th>
                <th style={s.th}>Email</th>
                <th style={s.th}>Role</th>
                <th style={s.th}>Área</th>
                <th style={s.th}>PM Ligado</th>
                <th style={s.th}>Ativo</th>
                <th style={s.th}>Último acesso</th>
                <th style={s.th}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {utilizadores.map((u) => (
                <tr key={u.user_id}>
                  <td style={s.td}>{u.nome ?? "—"}</td>
                  <td style={s.td}>{u.email}</td>
                  <td style={s.td}>
                    <select
                      style={s.select}
                      value={getValor(u, "role")}
                      onChange={(e) => handleChange(u.user_id, "role", e.target.value)}
                    >
                      {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
                    </select>
                  </td>
                  <td style={s.td}>
                    <select
                      style={s.select}
                      value={getValor(u, "area") ?? ""}
                      onChange={(e) => handleChange(u.user_id, "area", e.target.value || null)}
                    >
                      {AREAS.map((a) => (
                        <option key={a} value={a}>{a || "— Todas —"}</option>
                      ))}
                    </select>
                  </td>
                  <td style={s.td}>
                    <select
                      style={s.select}
                      value={getValor(u, "project_manager_id") ?? ""}
                      onChange={(e) => handleChange(u.user_id, "project_manager_id", e.target.value ? Number(e.target.value) : null)}
                      title="Ligação automática por email — só editar em caso de exceção"
                    >
                      <option value="">— Nenhum —</option>
                      {pms.map((pm) => (
                        <option key={pm.id} value={pm.id}>{pm.nome}</option>
                      ))}
                    </select>
                  </td>
                  <td style={s.td}>
                    <input
                      type="checkbox"
                      checked={getValor(u, "ativo") === 1}
                      onChange={(e) => handleChange(u.user_id, "ativo", e.target.checked ? 1 : 0)}
                    />
                  </td>
                  <td style={s.td}>
                    {u.ultimo_acesso ? u.ultimo_acesso.slice(0, 16).replace("T", " ") : "—"}
                  </td>
                  <td style={s.td}>
                    <button
                      style={s.btn}
                      onClick={() => guardar(u.user_id)}
                      disabled={salvando[u.user_id] || !editando[u.user_id]}
                    >
                      {salvando[u.user_id] ? "…" : "Guardar"}
                    </button>
                    {feedback[u.user_id] && (
                      <span style={feedback[u.user_id].tipo === "ok" ? s.ok : s.erro}>
                        {" "}{feedback[u.user_id].msg}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>

    </div>
  );
}

const s = {
  wrapper:    { display: "flex", flexDirection: "column", gap: 24 },
  section:    { background: "#fff", borderRadius: 8, padding: 24, boxShadow: "0 1px 3px rgba(0,0,0,.08)" },
  titulo:     { fontSize: 15, fontWeight: 600, margin: "0 0 8px", color: "#1e293b" },
  descricao:  { fontSize: 13, color: "#64748b", margin: "0 0 16px" },
  formRow:    { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
  input:      { padding: "6px 10px", border: "1px solid #cbd5e1", borderRadius: 4, fontSize: 13, minWidth: 280 },
  tabela:     { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th:         { textAlign: "left", padding: "8px 12px", backgroundColor: "#f8fafc", fontWeight: 600, borderBottom: "2px solid #e2e8f0", color: "#475569", whiteSpace: "nowrap" },
  td:         { padding: "8px 12px", color: "#374151", borderBottom: "1px solid #f1f5f9", verticalAlign: "middle" },
  select:     { padding: "4px 8px", border: "1px solid #cbd5e1", borderRadius: 4, fontSize: 13 },
  btn:        { padding: "4px 14px", backgroundColor: "#6366f1", color: "#fff", border: "none", borderRadius: 4, fontSize: 12, cursor: "pointer", fontWeight: 600 },
  btnRemover: { padding: "4px 10px", backgroundColor: "#fee2e2", color: "#dc2626", border: "none", borderRadius: 4, fontSize: 12, cursor: "pointer" },
  ok:         { fontSize: 11, color: "#16a34a" },
  erro:       { fontSize: 11, color: "#dc2626" },
  semDados:   { color: "#94a3b8", fontSize: 14, margin: 0 },
  loading:    { color: "#64748b" },
  linkGerado:    { marginTop: 16, padding: 12, background: "#fefce8", border: "1px solid #fde047", borderRadius: 6, fontSize: 13, color: "#713f12" },
  linkGeradoUrl: { marginTop: 6, fontFamily: "monospace", fontSize: 12, wordBreak: "break-all", userSelect: "all" },
};
